var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIconRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 6.5625C0.25 3.0762 3.0762 0.25 6.5625 0.25H29.4375C32.9238 0.25 35.75 3.0762 35.75 6.5625V29.4375C35.75 32.9238 32.9238 35.75 29.4375 35.75H6.5625C3.0762 35.75 0.25 32.9238 0.25 29.4375V6.5625Z",
    fill: "#C50023",
    stroke: "#CDCEC8",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 13C13.7 10.6241 15.6241 8.7 18 8.7C20.3759 8.7 22.3 10.6241 22.3 13C22.3 15.3759 20.3759 17.3 18 17.3C15.6241 17.3 13.7 15.3759 13.7 13ZM8.7 24.25C8.7 23.6758 8.98206 23.1211 9.56792 22.5804C10.1585 22.0353 11.0101 21.553 12.0087 21.1529C14.0072 20.3523 16.4188 19.95 18 19.95C19.5812 19.95 21.9928 20.3523 23.9913 21.1529C24.9899 21.553 25.8415 22.0353 26.4321 22.5804C27.0179 23.1211 27.3 23.6758 27.3 24.25V27.3H8.7V24.25Z",
    stroke: "white",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconRed);
export default __webpack_public_path__ + "static/media/profile-icon-red.318b147c.svg";
export { ForwardRef as ReactComponent };